import "../Styles/index.scss";

import { Fancybox } from "@fancyapps/ui/dist/fancybox";
import "./contact-form.svelte";

Fancybox.bind(".image-gallery > a");

for (const el of document.querySelectorAll(".button--cta")) {
	el.addEventListener("click", e => {
		document.dispatchEvent(new CustomEvent("open-contact-form"));
	});
}
